import { render, staticRenderFns } from "./outputRule.vue?vue&type=template&id=10a4b2a6&scoped=true&"
import script from "./outputRule.vue?vue&type=script&lang=js&"
export * from "./outputRule.vue?vue&type=script&lang=js&"
import style0 from "./outputRule.vue?vue&type=style&index=0&id=10a4b2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4b2a6",
  null
  
)

export default component.exports